import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AppContextProvider } from './context/AppContext';
import React, { Suspense } from 'react';
import SignIn from "./pages/SignIn";
import PrivateRoute from './components/PrivateRoute'
import ScrollToTop from './components/ScrollToTop';
import Loader from './components/Loader';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import IndexHome from './pages/Home';
import Error from './pages/Error';
import Profile from './pages/Profile';
import DownTown from './pages/DownTown';
import DownTownData from './pages/DownTownData';
import Location from './pages/Location';
import Project from './pages/Project';
import Category from './pages/Category';
import Product from './pages/Product';
import ViewData from './pages/ViewData';
import Activity from './pages/Activity';
import NewDownTownData from './pages/NewDownTownData';
import SearchData from './pages/SearchData';
import RecycleBin from './pages/RecycleBin';
import TopData from './pages/TopData';
import ColoumUpdation from './pages/ColoumUpdation';
import DashboardNewIndex from './pages/new_dashboard/Index';
import Type from './pages/Type';



window.Buffer = window.Buffer || require("buffer").Buffer;
function App() {

  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={false} />
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<SignIn />} />
      {/* <Route path="/" element={<SignIn />} /> */}
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>} >
        {/* <Route exact path="/" element={<IndexHome />} /> */}
        <Route exact path="/dashboard" element={<IndexHome />} />
        <Route exact path="/" element={<DashboardNewIndex />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/file-manager" element={<DownTown />} />
        <Route exact path="/recycle-bin" element={<RecycleBin />} />
        <Route exact path="/data-excel/:type/:id" element={<DownTownData />} />
        <Route exact path="/new-page/:type" element={<NewDownTownData />} />
        <Route exact path="/location-manager" element={<Location />} />
        <Route exact path="/project-manager" element={<Project />} />
        <Route exact path="/type-manager" element={<Type />} />
        {/* <Route exact path="/category-manager" element={<Category />} />
        <Route exact path="/product-manager" element={<Product />} /> */}
        <Route exact path="/view-data/:id/:type" element={<ViewData />} />
        <Route exact path="/activity-list/:id" element={<Activity />} />
        <Route exact path="/search-data" element={<SearchData />} />
        <Route exact path="/top-data" element={<TopData />} />
        <Route exact path="/db-coloum" element={<ColoumUpdation />} />


      </Route>
      <Route path="*" element={<Error />} />
    </Routes>
  )
}

const Layout = () => {
  return (<> <Outlet />  </>
  )
}


export default App;
